/**
 * @generated SignedSource<<5bc24fa84d3793b07bce29c32068ba3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EmailQuery$variables = {
  key: string;
};
export type EmailQuery$data = {
  readonly loginActivation: {
    readonly email: string | null;
  } | null;
};
export type EmailQuery = {
  response: EmailQuery$data;
  variables: EmailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoginActivation",
        "kind": "LinkedField",
        "name": "loginActivation",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoginActivation",
        "kind": "LinkedField",
        "name": "loginActivation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f35c1f81020ab286f2fd7f06b97b3bbd",
    "id": null,
    "metadata": {},
    "name": "EmailQuery",
    "operationKind": "query",
    "text": "query EmailQuery(\n  $key: String!\n) {\n  loginActivation(key: $key) {\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "29a17d558352b309529549e22ed5aff8";

export default node;
